import { Component, OnInit  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { UserInfo } from '../../models/account/userInfo';
import { Parameter } from '../../models/account/parameter';

import { AccountService } from '../../services/account/account.service';

@Component({
    selector: 'account',
    template: require('./../../templates/account/accountView.component.html'),
    styles: [require('./../../styles/account/accountView.component.css')],
    providers: [AccountService]
})
export class AccountViewComponent implements OnInit {
    userInfo: UserInfo = {
        isAuthenticated: false,
        userName: '',
        name: '',
        email: '',
        claims: new Array<Parameter>(),
        is2FAEnabled: false,
        is2FARequired: false
    };
    errorMessage: string;
    isAuthenticated: boolean = false;

    constructor(private accountService: AccountService) {
        this.isAuthenticated = false;
    }

    ngOnInit() {
        this.accountService.isAuthenticated(userInfo => {
            this.userInfo = userInfo;
            this.isAuthenticated = userInfo.isAuthenticated;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/account/accountView.component.ts